import { ready, onShopifySectionLoad } from '../utils/readyinit';
import { EVENTS } from '../utils/constants';
import initProductCards from '../components/product-card';
import initCollectionSearchFilters from '../sections/collection/initCollectionSearchFilters';
import initSortRadios from '../sections/collection/initSortRadios';
import initLoadMore from '../sections/collection/initLoadMore';
import initSkuSearch from '../sections/collection/initSkuSearch';
import initCompare from '../components/compare';

// Cards fetched by filtering or load-more arrive uninitialised (dead ATC
// button, inert swatches) — initProductCards is idempotent via data-card-init.
document.addEventListener(EVENTS.COLLECTION_RERENDER, () => initProductCards());

ready(() => {
  initCollectionSearchFilters();
  initSortRadios();
  initLoadMore();
  initSkuSearch();
  initCompare();
});

onShopifySectionLoad(() => {
  initCollectionSearchFilters();
  initSortRadios();
  initLoadMore();
  initSkuSearch();
  initCompare();
});
